import { render, staticRenderFns } from "./HearingFilter.vue?vue&type=template&id=52ad2b89"
import script from "./HearingFilter.vue?vue&type=script&lang=js"
export * from "./HearingFilter.vue?vue&type=script&lang=js"
import style0 from "./HearingFilter.vue?vue&type=style&index=0&id=52ad2b89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports